import { Vector3 } from 'three';
import SimpleMeasurementModel from '../../models/standard/SimpleMeasurementModel';

// Helper function to deserialize a measurement.
export default function deserializeMeasurement(m: any): SimpleMeasurementModel {
  const startPoint = new Vector3(m.startPoint.x, m.startPoint.y, m.startPoint.z);
  const endPoint = m.endPoint ? new Vector3(m.endPoint.x, m.endPoint.y, m.endPoint.z) : null;
  const firstName = '';
  const lastName = '';

  return new SimpleMeasurementModel(m.id, startPoint, endPoint, m.color, m.userId, firstName, lastName, new Date(m.creationDate));
}
